// extracted by mini-css-extract-plugin
module.exports = {"pageBackground":"products_pageBackground__Vu66L","wrapper":"products_wrapper__JOjEN"};